import styled from 'styled-components'

export const AccessibilityComponent = styled.div`
  margin-top: 10px;

  @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
    margin: 0 15px;
  }

  ul {
    list-style: none;
    padding: 0;
    margin-bottom: 20px;

    li + li {
      margin-top: 20px;
    }

    @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
      &:last-child {
        margin-bottom: 30px;
      }
    }

    li {
      display: flex;
      gap: 15px;
    }
  }

  .list-headline {
    margin-bottom: 20px;
  }

  .list-icon > svg {
    color: ${ (props) => props.theme.colors['panel-inner-border'] };
  }

  .icons {
    display: flex;
    flex-direction: row;
    gap: 8px;
  }

  .description {
    align-self: center;
  }
`
